<div class="course-picker-container">
  <!-- Loading state -->
  @if (loading) {
    <div class="loading-indicator">
      Lade verfügbare Kurse...
    </div>
  } @else if (!courseSessions.length) {
    <!-- No courses message -->
    <div class="no-courses-message">
      Keine Kurse verfügbar für diese Zeit
    </div>
  } @else {
    <!-- Selection cards (ARIA radio group: native buttons give Enter/Space
         activation, roving tabindex + arrow keys handled in the component) -->
    <div
      class="course-cards"
      role="radiogroup"
      aria-label="Verfügbare Kurse"
      (keydown)="onRadioKeydown($event)">
      @for (session of courseSessions; track session.id) {
        <button
          #courseRadio
          type="button"
          role="radio"
          class="course-card"
          [class.selected]="isSelected(session)"
          [class.unavailable]="!isSelectable(session)"
          [attr.aria-checked]="isSelected(session)"
          [disabled]="!isSelectable(session)"
          [tabindex]="tabIndexFor(session)"
          (click)="selectSession(session)">

          <div class="course-card-inner">
            <div class="course-info">
              <div class="course-name-line">
                <span class="course-name">{{ session.displayName }}</span>
                <span class="course-badge">{{ kindLabel(session) }}</span>
              </div>
              <div class="course-meta">{{ getMetaLine(session) }}</div>
              @if (isSelectable(session)) {
                <div class="course-spots">{{ getSpotsLabel(session) }}</div>
              } @else {
                <div class="course-status">{{ getStatusLabel(session) }}</div>
              }
            </div>

            <div class="course-side">
              <span class="course-price">{{ formatPrice(session.priceForUser ?? session.regularPrice) }}</span>
              @if (isSelectable(session)) {
                <span class="radio-outer" [class.checked]="isSelected(session)">
                  <span class="radio-inner"></span>
                </span>
              }
            </div>
          </div>
        </button>
      }
    </div>
  }
</div>
